import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams, useLocation } from "react-router-dom";
import { FaCheckCircle } from 'react-icons/fa';
import TopHeader from '../../Header/TopHeader';
import Navbar from '../../Header/Navbar';
import Footer from '../../Footer/Footer';
import Breadcrumb from '../../Screens/Breadcrumb';
import PopularService from '../PopularService';
import '../../Css/PropertiesShip.css';
import '../../Css/DocumentRequire.css';

function Loan() {
    const { slug } = useParams();
    const location = useLocation();
    const id = location.state?.id;
    const serviceName = location.state?.serviceName;
    
    const [processData, setProcessData] = useState([]);
    const [serviceData, setServiceData] = useState({});
    const [servicesList, setServicesList] = useState([]);
    const [loading, setLoading] = useState(true);

    const getProcessData = async () => {
        try {
            const { data } = await axios.get(`https://api.compliancekare.com/api/Compliance/RegistrationProcessList?BusinessId=${id}`);
            setProcessData(data.data || []);
        } catch (error) {
            console.error("Error fetching process data:", error);
        }
    };

    const getServiceData = async () => {
        try {
            const { data } = await axios.get(`https://api.compliancekare.com/api/Compliance/LoanDetailList?LoanId=${id}`);
            setServiceData(data.id || {});
            setServicesList(data.services || []);
        } catch (error) {
            try {
                // Fallback to general ServiceDetailList if specific endpoint fails (e.g., 404 for PAN Application)
                const { data } = await axios.get(`https://api.compliancekare.com/api/Compliance/ServiceDetailList?BusinessId=${id}`);
                setServiceData(data.id || {});
                setServicesList(data.services || []);
            } catch (fallbackError) {
                console.error("Error fetching service data:", fallbackError);
            }
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            if (id) {
                await Promise.all([getProcessData(), getServiceData()]);
            }
            setLoading(false);
        };
        fetchData();
    }, [id]);

    const title = serviceName || serviceData.loanTypeName || "Loan";

    return (
        <>
            <TopHeader />
            <Navbar />
            <div className="proprietorship-hero-banner">
                <div className="container h-100 position-relative z-index-2">
                    <div className="row h-100 align-items-center py-5">
                        <div className="col-lg-12 text-white text-start">
                            <div className="d-flex align-items-center mb-2">
                                <div className="hero-eyebrow-line"></div>
                                <span className="hero-eyebrow-text ms-2">Start Your Business Journey with</span>
                            </div>
                            <h1 className="hero-main-heading">{title}</h1>
                            <p className="hero-tagline"><span className="text-lime">/</span> Fast, Secure & Hassle-Free Services</p>
                            
                            <div className="hero-breadcrumb mb-4">
                                <span>Home</span> <span className="text-lime mx-2">/</span> <span className="text-lime">{title}</span>
                            </div>
                            
                            <div className="hero-features-container mt-4">
                                <div className="hero-feature-card">
                                    <div className="hero-feature-icon">
                                        <i className="bi bi-rocket-takeoff"></i>
                                    </div>
                                    <div className="hero-feature-text">
                                        <h6 className="mb-0 text-white fw-bold">Easy Registration</h6>
                                        <small className="text-light-blue">Quick & Hassle-Free Process</small>
                                    </div>
                                </div>
                                <div className="hero-feature-card">
                                    <div className="hero-feature-icon">
                                        <i className="bi bi-person-fill"></i>
                                    </div>
                                    <div className="hero-feature-text">
                                        <h6 className="mb-0 text-white fw-bold">Full Control</h6>
                                        <small className="text-light-blue">100% Ownership and Decision Making</small>
                                    </div>
                                </div>
                                <div className="hero-feature-card">
                                    <div className="hero-feature-icon">
                                        <i className="bi bi-graph-up-arrow"></i>
                                    </div>
                                    <div className="hero-feature-text">
                                        <h6 className="mb-0 text-white fw-bold">Low Compliance</h6>
                                        <small className="text-light-blue">Simple Legal & Tax Requirements</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Background decorations */}
                <div className="hero-bg-glow"></div>
                <div className="hero-bg-wave"></div>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
                        .proprietorship-hero-banner {
                            background: linear-gradient(135deg, #09304e 0%, #0d4670 100%);
                            position: relative;
                            overflow: hidden;
                            min-height: 450px;
                            display: flex;
                            align-items: center;
                        }
                        .hero-bg-glow {
                            position: absolute;
                            top: -20%;
                            left: 10%;
                            width: 600px;
                            height: 600px;
                            background: radial-gradient(circle, rgba(137, 199, 100, 0.15) 0%, rgba(0,0,0,0) 70%);
                            z-index: 1;
                        }
                        .hero-bg-wave {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 100px;
                            background: url('data:image/svg+xml;utf8,<svg viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg"><path fill="%2389c764" fill-opacity="0.2" d="M0,256L80,245.3C160,235,320,213,480,213.3C640,213,800,235,960,240C1120,245,1280,235,1360,229.3L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>') no-repeat bottom;
                            background-size: cover;
                            z-index: 1;
                        }
                        .z-index-2 {
                            z-index: 2;
                        }
                        .hero-eyebrow-line {
                            width: 40px;
                            height: 2px;
                            background-color: #89c764;
                        }
                        .hero-eyebrow-text {
                            font-size: 1.1rem;
                            color: #f1f5f9;
                            letter-spacing: 0.5px;
                        }
                        .hero-main-heading {
                            font-size: 4.5rem;
                            font-weight: 800;
                            color: #ffffff;
                            text-shadow: 0 4px 15px rgba(0,0,0,0.2);
                            margin: 5px 0 10px 0;
                            line-height: 1.1;
                        }
                        .hero-tagline {
                            font-size: 1.3rem;
                            color: #e2e8f0;
                            font-weight: 500;
                        }
                        .text-lime {
                            color: #89c764;
                        }
                        .text-light-blue {
                            color: #cbd5e1;
                            font-size: 0.85rem;
                        }
                        .hero-breadcrumb {
                            font-size: 0.95rem;
                            color: #cbd5e1;
                        }
                        .hero-features-container {
                            display: flex;
                            gap: 15px;
                            flex-wrap: wrap;
                        }
                        .hero-feature-card {
                            background: rgba(13, 70, 112, 0.6);
                            border: 1px solid rgba(137, 199, 100, 0.3);
                            backdrop-filter: blur(10px);
                            border-radius: 12px;
                            padding: 15px;
                            display: flex;
                            align-items: center;
                            gap: 15px;
                            flex: 1;
                            min-width: 240px;
                            transition: transform 0.3s ease, background 0.3s ease;
                        }
                        .hero-feature-card:hover {
                            transform: translateY(-5px);
                            background: rgba(13, 70, 112, 0.9);
                            border-color: #89c764;
                        }
                        .hero-feature-icon {
                            font-size: 24px;
                            color: #89c764;
                            background: rgba(137, 199, 100, 0.1);
                            width: 50px;
                            height: 50px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 50%;
                            flex-shrink: 0;
                            border: 1px solid rgba(137, 199, 100, 0.2);
                        }
                        @media (max-width: 991px) {
                            .hero-main-heading { font-size: 3rem; }
                        }
                    `}} />            
            <div className="service-page-wrapper py-5">
                <div className="container">
                    <div className="row g-4">
                        {/* MAIN CONTENT (LEFT) */}
                        <div className="col-lg-8">
                            
                            {/* Title and Description */}
                            <div className="service-detail-card mb-4">
                                <h2 className="service-title">{title}</h2>
                                <hr className="title-divider" />
                                <div 
                                    className="service-description" 
                                    dangerouslySetInnerHTML={{ __html: serviceData.proprietorshipDescription || '' }}
                                ></div>
                            </div>

                            {/* Pricing Overview */}
                            <div className="pricing-summary-card mb-4">
                                <div className="row text-center">
                                    <div className="col-md-4 pricing-item">
                                        <p className="text-muted mb-1">Market Price</p>
                                        <h4 className="text-decoration-line-through text-danger">₹{serviceData.marketPrice || '0'}.00</h4>
                                    </div>
                                    <div className="col-md-4 pricing-item border-start border-end">
                                        <p className="text-muted mb-1">Our Price</p>
                                        <h4 className="text-success fw-bold">₹{serviceData.price || '0'}.00</h4>
                                    </div>
                                    <div className="col-md-4 pricing-item">
                                        <p className="text-muted mb-1">You Save</p>
                                        <h4 className="text-primary fw-bold">₹{serviceData.savePrice || '0'}.00</h4>
                                    </div>
                                </div>
                            </div>

                            {/* Included Services List */}
                            {servicesList && servicesList.length > 0 && (
                                <div className="included-services-card mb-4">
                                    <h4 className="fw-bold mb-3">Package Includes</h4>
                                    <div className="row g-3">
                                        {servicesList.map((item, index) => (
                                            <div className="col-md-6 d-flex align-items-center" key={index}>
                                                <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                                                <span>{item.service}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                       </div>

                        {/* SIDEBAR (RIGHT) */}
                        <div className="col-lg-4">
                            <div className="sticky-sidebar-card">
                                <h4 className="fw-bold mb-3 text-primary">Secure Checkout</h4>
                                <p className="text-muted small mb-4">Complete your payment details to start processing your registration instantly.</p>
                                
                                <div className="sidebar-price-box mb-4">
                                    <span className="text-muted small d-block mb-1">Package Pricing</span>
                                    <h3 className="fw-extrabold m-0 text-primary" style={{ fontSize: "28px" }}>
                                        ₹{serviceData.packageFee || serviceData.price || "0"}.00
                                    </h3>
                                </div>

                                <Link to="/contact" className="sidebar-pay-btn w-100 mb-4">
                                    💳 Pay Now
                                </Link>

                                <div className="border-top pt-4 text-start">
                                    <div className="sidebar-benefit-item">
                                        <span>✔</span> 100% Assured Services
                                    </div>
                                    <div className="sidebar-benefit-item">
                                        <span>✔</span> Expert CA Consultation
                                    </div>
                                    <div className="sidebar-benefit-item">
                                        <span>✔</span> Secure Encrypted Transaction
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                            {/* Registration Process Grid */}
                            {processData && processData.length > 0 && (
                                <div className="process-grid-wrapper mt-5 mb-4">
                                    <h4 className="fw-bold mb-4 text-center" style={{ color: "#115886" }}>Registration Process</h4>
                                    <div className="process-grid-container">
                                        {processData.map((step, index) => {
                                            const processImages = [
                                                "https://assets.vakilsearch.com/expert.svg",
                                                "https://assets.vakilsearch.com/docu.svg",
                                                "https://assets.vakilsearch.com/docu.svg",
                                                "https://assets.vakilsearch.com/certificate.svg"
                                            ];
                                            const imgUrl = processImages[index % processImages.length];
                                            return (
                                                <div className="process-grid-card" key={index}>
                                                    <div className="grid-img-wrapper">
                                                        <img src={imgUrl} alt="Process Step" />
                                                    </div>
                                                    <span className="grid-day-badge">{step.days || `Day ${index + 1} - ${index + 2}`}</span>
                                                    <div className="grid-html-content" dangerouslySetInnerHTML={{ __html: step?.registrationProcess || '' }}></div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
 
                </div>
            </div>
            
            <PopularService />
            <Footer />
        </>
    );
}

export default Loan;